import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/utils/http';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shareCloseShow: true,
    userInfo: null,
    token: localStorage.getItem('token') || '',
    remainingPoints: localStorage.getItem('remainingPoints'),
    pointMonth2: null,
    continueList: [],
    usageCount: null,
    writeFiveBooksForm: {},  // 专利五书 - 将被持久化
    allHistoryDetail: {},    // 所有历史记录详情 - 将被持久化
    aiSearchObj: {},
    technicalStep: 0,
    activeName: '1',
    assistantBook: null,
    searchNameActive: '1',
    historyListShow: false, // 初始状态
    InventionDrafting: null,  //一键撰写全文
    creativeNaming: null,// 创意命名
  },
  mutations: {
    setShareCloseShow(state, value) {
      state.shareCloseShow = value
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setRemainingPoints(state, remainingPoints) {
      state.remainingPoints = remainingPoints;
      localStorage.setItem('remainingPoints', JSON.stringify(remainingPoints))
    },
    setPointMonth2(state, pointMonth2) {
      state.pointMonth2 = pointMonth2;
      localStorage.setItem('pointMonth', JSON.stringify(pointMonth2))
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    clearToken(state) {
      state.token = '';
      state.userInfo = null
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('remainingPoints');
      localStorage.removeItem('userInfo2');
      localStorage.removeItem('pointMonth');
      localStorage.removeItem('vuex_patent_data');
      localStorage.removeItem('websiteTabIndex');
      // 同时重置会被持久化的状态
      state.allHistoryDetail = {};
      state.writeFiveBooksForm = {};
      state.aiSearchObj = {};
      state.technicalStep = 0
      state.activeName = '1'
      state.assistantBook = null
      state.searchNameActive = '1'
      state.InventionDrafting = null
      sessionStorage.removeItem('tempSearch');
    },
    setContinueList(state, continueList) {
      state.continueList = continueList
    },
    UPDATE_ALL_ACTIVE_STATE(state, isActive) {
      state.continueList.forEach(item => {
        Vue.set(item, 'isActive', isActive);
      });
    },
    setUsageCount(state, count) {
      state.usageCount = count
    },
    setWriteFiveBook(state, writeFive) {
      state.writeFiveBooksForm = writeFive
    },
    setAllHistoryDetail(state, detail) {
      state.allHistoryDetail = detail
    },
    setAISearch(state, aiSearch) {
      state.aiSearchObj = aiSearch
    },
    setTechnicalStep(state, step) {
      state.technicalStep = step
    },
    setActiveName(state, active) {
      state.activeName = active
    },
    setAssistant(state, value) {
      state.assistantBook = value
    },
    setSearchNameActive(state, active) {
      state.searchNameActive = active
    },
    TOGGLE_HISTORY_LIST(state) {
      state.historyListShow = !state.historyListShow
    },
    SET_HISTORY_LIST(state, status) {
      state.historyListShow = status
    },
    setInventionDrafting(state, value) {
      state.InventionDrafting = value
    },
    setCreativeNaming(state, value) {
      state.creativeNaming = value
    }
  },
  actions: {
    closeShare({ commit }) {
      commit('setShareCloseShow', false)
    },
    fetchUserInfo({ commit }) {
      http.get('/customerusers/user/owner').then((res) => {
  
        if (res.code === 200) {
          let userData = res.data
          userData.role = 'user';
          if (userData.vipInfo != null) {
            userData.vipInfo.vipTemplateInfo = JSON.parse(userData.vipInfo.vipTemplateInfo);
          }
          localStorage.setItem("userInfo", JSON.stringify(userData));
          commit('setUserInfo', userData);
        }
      });
    },
    getCustoerusersPot({ commit }) {
      http.get('/customerusers/master/user/amount').then((res) => {
        if (res.code === 200) {
          commit('setRemainingPoints', res.data);
        }
      })
    },
    getPointMonth({ commit }) {
      http.get('/owner/accounttraces/month').then((res) => {
        if (res.code === 200) {
          commit('setPointMonth2', res.data);
        }
      })
    },
    updateAllActiveState({ commit }, isActive) {
      commit('UPDATE_ALL_ACTIVE_STATE', isActive);
    },
  },
  getters: {
    isShareVisible: state => state.shareCloseShow,
    userInfo: state => state.userInfo,
    hasToken: state => !!state.token,
    getPoint: state => state.remainingPoints,
    usePoint: state => state.pointMonth2,
    getContinueList: state => state.continueList,
    getterUserCount: state => state.usageCount,
    getterWriteFiveBooks: state => state.writeFiveBooksForm,
    getterHistoryDetail: state => state.allHistoryDetail,
    getterAiSearchObj: state => state.aiSearchObj,
    getterTechnicalStep: state => state.technicalStep,
    getterActiveName: state => state.activeName,
    getterSetAssistant: state => state.assistantBook,
    getterSearchNameActive: state => state.searchNameActive,
    getterInventionDrafting: state => state.InventionDrafting,
    getterCreativeNaming: state => state.creativeNaming,

  },
  plugins: [
    createPersistedState({
      key: 'vuex_patent_data', // 使用更具体的key名
      paths: [
        'activeName',
        'searchNameActive',
        'technicalStep',
        'allHistoryDetail',
        'assistantBook',
        // 'writeFiveBooksForm'
        'aiSearchObj',
        'InventionDrafting',
        'creativeNaming',
      ],
      storage: window.localStorage
    })
  ]
})